<template>
  <Mmask @close="close">
    <div class="lantitle">
      <span :class="lan == 'ar' ? 'ar' : ''">{{ $t("message.strid4") }}</span>
    </div>
    <div class="lanList" :class="lan == 'ar' ? 'ar' : ''">
      <a
        class="item"
        :href="item.url"
        target="_blank"
        v-for="(item, index) in list"
        :key="index"
      >
        <img :src="item.img" alt="" />
        {{ item.name }}
      </a>
    </div>
  </Mmask>
</template>

<script>
import Mmask from "@/components/mask";
export default {
  components: {
    Mmask,
  },
  data() {
    return {};
  },
  props: ["list", "lan"],
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/mask.scss";
.mask-box .bg-box .lanList .item {
  width: 80%;
  vertical-align: middle;

  img {
    @include wh(72, 72);
    vertical-align: middle;
  }
}
.ar {
    direction: rtl;
    unicode-bidi: bidi-override;
}
</style>
